import React, { useEffect } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import CommanTasks from './CommanTasks';
import AccommodationTasks from './AccommodationLiveTasks';
import CommanLiveTasks from './CommanLiveTasks';
import Loader from '../../shared/components/ui/Loader';
import { useSidebar } from '../../shared/contexts/SidebarContext';

import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../../uiSlice';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const LiveTasks = () => {
  const userId = Cookies.get('userId');
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.ui.activeTab);
  const [isloading, setisLoading] = React.useState(false);
  const { collapsed } = useSidebar();

  // Update active tab in redux
  const handleTabChange = (tab) => {
    dispatch(setActiveTab(tab));
  };

  return (
    <>
      <Loader isVisible={isloading} />
      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header backArrow={false} data={{ name: 'Live Tasks' }} />
        </div>

        {/* Tabs */}
        <div
          className={`fixed top-[4.1rem] z-30 bg-white px-6 py-3 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <div className="flex gap-8">
            <button
              className={`text-[1rem] font-semibold transition-colors duration-200 ${
                activeTab === 'commonTasks' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
              }`}
              onClick={() => handleTabChange('commonTasks')}>
              Common Tasks
            </button>
            <button
              className={`text-[1rem] font-semibold transition-colors duration-200 ${
                activeTab === 'accommodation'
                  ? 'text-[#2A565E]'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
              onClick={() => handleTabChange('accommodation')}>
              Accommodation Tasks
            </button>
          </div>
          <div className="mt-1">
            <div
              className="h-[2px] bg-[#2A565E] transition-all duration-300"
              style={{
                width: activeTab === 'commonTasks' ? '110px' : '165px',
                transform: `translateX(${activeTab === 'commonTasks' ? '0' : '140px'})`
              }}
            />
          </div>
        </div>

        <GridWrapper width={100}>
          {activeTab === 'commonTasks' ? (
            <CommanLiveTasks setisLoading={setisLoading} />
          ) : (
            <AccommodationTasks setisLoading={setisLoading} mainTab={activeTab} />
          )}
        </GridWrapper>
      </Layout>
    </>
  );
};

export default LiveTasks;
